'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderColor = exports.activeBackgroundColor = exports.hoverBackgroundColor = exports.backgroundColor = exports.color = exports.fontSize = exports.padding = exports.borderRadius = exports.minWidth = exports.width = undefined;

var _T2 = require('ramda/src/T');

var _T3 = _interopRequireDefault(_T2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _anyPass2 = require('ramda/src/anyPass');

var _anyPass3 = _interopRequireDefault(_anyPass2);

var _always2 = require('ramda/src/always');

var _always3 = _interopRequireDefault(_always2);

var _propEq2 = require('ramda/src/propEq');

var _propEq3 = _interopRequireDefault(_propEq2);

var _cond2 = require('ramda/src/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _mcsLiteTheme = require('mcs-lite-theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SMALL = 'small';

var DEFAULT = 'default';

var width = exports.width = (0, _cond3.default)([[(0, _propEq3.default)('block', true), (0, _always3.default)('100%')], [(0, _anyPass3.default)([(0, _propEq3.default)('square', true), (0, _propEq3.default)('round', true)]), (0, _path3.default)(['theme', 'height', 'normal'])], [_T3.default, (0, _always3.default)('initial')]]);

var minWidth = exports.minWidth = (0, _cond3.default)([[(0, _anyPass3.default)([(0, _propEq3.default)('block', true), (0, _propEq3.default)('square', true), (0, _propEq3.default)('round', true)]), (0, _always3.default)('initial')], [(0, _propEq3.default)('size', SMALL), (0, _always3.default)('40px')], [_T3.default, (0, _always3.default)('80px')]]);

var borderRadius = exports.borderRadius = (0, _cond3.default)([[(0, _propEq3.default)('round', true), (0, _always3.default)('50%')], [_T3.default, (0, _always3.default)('3px')]]);

var padding = exports.padding = (0, _cond3.default)([[(0, _anyPass3.default)([(0, _propEq3.default)('square', true), (0, _propEq3.default)('round', true)]), (0, _always3.default)('0')], [(0, _propEq3.default)('size', SMALL), (0, _always3.default)('0 5px')], [_T3.default, (0, _always3.default)('6px 15px')]]);

var fontSize = exports.fontSize = (0, _cond3.default)([[(0, _propEq3.default)('size', SMALL), (0, _path3.default)(['theme', 'fontSize', 'small'])], [_T3.default, (0, _path3.default)(['theme', 'fontSize', 'p'])]]);

var color = exports.color = (0, _cond3.default)([[(0, _propEq3.default)('kind', DEFAULT), (0, _path3.default)(['theme', 'color', 'grayDark'])], [_T3.default, (0, _path3.default)(['theme', 'color', 'white'])]]);

var backgroundColor = exports.backgroundColor = (0, _cond3.default)([[(0, _propEq3.default)('active', true), function (props) {
  return (0, _mcsLiteTheme.darken2)(props.theme.color[props.kind]);
}], [(0, _propEq3.default)('disabled', true), (0, _path3.default)(['theme', 'color', 'grayBase'])], [_T3.default, function (props) {
  return props.theme.color[props.kind];
}]]);

var hoverBackgroundColor = exports.hoverBackgroundColor = (0, _cond3.default)([[(0, _propEq3.default)('disabled', true), (0, _path3.default)(['theme', 'color', 'grayBase'])], [_T3.default, function (props) {
  return (0, _mcsLiteTheme.darken1)(props.theme.color[props.kind]);
}]]);

var activeBackgroundColor = exports.activeBackgroundColor = (0, _cond3.default)([[(0, _propEq3.default)('disabled', true), (0, _path3.default)(['theme', 'color', 'grayBase'])], [_T3.default, function (props) {
  return (0, _mcsLiteTheme.darken2)(props.theme.color[props.kind]);
}]]);

var borderColor = exports.borderColor = (0, _cond3.default)([[(0, _propEq3.default)('disabled', true), function (props) {
  return (0, _mcsLiteTheme.darken3)(props.theme.color.grayBase);
}], [_T3.default, function (props) {
  return (0, _mcsLiteTheme.darken3)(props.theme.color[props.kind]);
}]]);


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Button/propMappers.js
// module id = 347
// module chunks = 4